<style lang="less" scoped>
.chart-button {
  width: 90px;
}
.first-top-div {
  height: 60px;
  line-height: 60px;
  font-size: 14px;
}
.first-top-div div {
  margin-right: 40px;
}
.margin-bottom-10 {
  margin-bottom: 10px;
}
.middle-top-div {
  height: 60px;
  line-height: 60px;
}
.middle-button-div {
  justify-content: space-between;
  border-radius: 8px;
  border: 2px solid #eaeaea;
  padding: 30px 0;
}
.first-middle-div {
  font-size: 14px;
  height: 240px;
}
.mes-div {
  width: 340px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 50px;
}
.mes-title {
  width: 150px;
}
.mes-content {
  height: 35px;
  line-height: 38px;
  justify-content: space-around;
}
.border-right {
  border-right: solid 1px gray;
}
.line-title {
  width: 10%;
  font-size: 14px;
  text-align: center;
  padding-top: 50px;
}
.line-data-tab {
  justify-content: flex-end;
  align-items: center;
  p {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #a3a9af;
    line-height: 20px;
    margin: 0 15px;
  }
  i {
    position: absolute;
    bottom: -3px;
    right: 0;
    width: 20px;
    height: 2px;
    background: linear-gradient(205deg, #b780f3 0%, #59bdff 100%);
    border-radius: 2px;
  }
}
.position-r {
  position: relative;
  font-weight: 500 !important;
  color: #000000 !important;
}
.line-data {
  & > div {
    margin: 50px 0 0;
  }
}
</style>

<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb
        :bConfigList="pageConfig.detailBreadCrumb"
      ></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">{{ pageTitle }}</div>
      </div>
      <div class="detail-content-body-div flex-1">
        <div class="first-top-div flex">
          <div class="first-title-div">运营商：</div>
          <div>{{ detailForm.dealName }}</div>
          <div style="margin-right:120px">{{ detailForm.dealNo }}</div>
          <div class="first-title-div">电站：</div>
          <div>{{ detailForm.stationName }}</div>
          <div>{{ detailForm.stationNo }}</div>
        </div>
        <el-divider></el-divider>
        <div class="first-middle-div">
          <!-- <div class="middle-top-div flex">
                        <div>电站报表</div>
                    </div> -->
          <div class="middle-button-div flex">
            <div class="mes-div">
              <div class="mes-content flex">
                <div class="mes-title">充电桩</div>
                <div>{{ pileStationRptDto.pileNum }}&nbsp;&nbsp;&nbsp;根</div>
              </div>
              <div class="mes-content flex">
                <div class="mes-title">离网桩</div>
                <div>
                  {{ pileStationRptDto.offlinePileNum }}&nbsp;&nbsp;&nbsp;根
                </div>
              </div>
              <div class="mes-content flex">
                <div class="mes-title">故障桩</div>
                <div>
                  {{ pileStationRptDto.errorPileNum }}&nbsp;&nbsp;&nbsp;根
                </div>
              </div>
            </div>
            <div class="mes-div">
              <div class="mes-content flex">
                <div class="mes-title">当前单价</div>
                <div v-if="pileStationRptDto.chargeFee">
                  {{ pileStationRptDto.chargeFee }}&nbsp;&nbsp;&nbsp;元
                </div>
              </div>
              <div class="mes-content flex">
                <div class="mes-title">总充电量</div>
                <!-- <div v-if="pileStationRptDto.chargeSum == 0">{{pileStationRptDto.chargeSum}}&nbsp;&nbsp;&nbsp;kW·h</div> -->
                <div>
                  {{ pileStationRptDto.chargeSum }}&nbsp;&nbsp;&nbsp;kW·h
                </div>
                <!-- <div v-else>{{pileStationRptDto.chargeSum.toFixed(2)}}&nbsp;&nbsp;&nbsp;kW·h</div> -->
              </div>
              <div class="mes-content flex">
                <div class="mes-title">订单总量</div>
                <div>{{ pileStationRptDto.orderNum }}&nbsp;&nbsp;&nbsp;单</div>
              </div>
              <div class="mes-content flex">
                <div class="mes-title">用户总量</div>
                <div>{{ pileStationRptDto.custNum }}&nbsp;&nbsp;&nbsp;人</div>
              </div>
            </div>
            <div class="mes-div">
              <div class="mes-content flex">
                <div class="mes-title">金额总计</div>
                <div>{{ pileStationRptDto.feeSum }}&nbsp;&nbsp;&nbsp;元</div>
              </div>
              <div class="mes-content flex">
                <div class="mes-title">平台抵扣电度</div>
                <div>
                  {{ pileStationRptDto.appFeeSum }}&nbsp;&nbsp;&nbsp;电度
                </div>
              </div>
              <div class="mes-content flex">
                <div class="mes-title">自营抵扣电度</div>
                <div>
                  {{ pileStationRptDto.ownerFeeSum }}&nbsp;&nbsp;&nbsp;电度
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-divider></el-divider>
        <div class="first-top-div flex">
          <div class="first-title-div">入网申请表：</div>
          <a
            class="btn-title"
            :href="detailForm.filePath"
            :download="detailForm.fileName"
            v-if="detailForm.filePath != '/api/v1'"
            >下载</a
          >
          <div style="margin-right:120px">{{ detailForm.dealNo }}</div>
          <div class="first-title-div">更新人：</div>
          <div>{{ detailForm.lastModifiedByName }}</div>
          <div class="first-title-div">更新时间：</div>
          <div>{{ detailForm.lastModifiedWhen }}</div>
        </div>
        <el-divider></el-divider>
        <div>
          <div class="flex line-data-tab">
            <p class="position-r" @click="handleDayClick">
              <span>近七日</span>
              <i class="tab-unline" v-if="lineChartType == 'day'"></i>
            </p>
            <p class="position-r" @click="handleMonthClick">
              <span>本月</span>
              <i class="tab-unline" v-if="lineChartType == 'month'"></i>
            </p>
            <p class="position-r" @click="handleYearClick">
              <span>本年度</span>
              <i class="tab-unline" v-if="lineChartType == 'year'"></i>
            </p>
          </div>
          <div class="line-data">
            <div class="flex">
              <div class="line-title">
                {{ lineTitle }}订单金额<br /><br />{{ feeSum }}元
              </div>
              <!-- <div class="line-title">{{lineTitle}}订单金额</div> -->
              <station-line
                v-if="flag"
                :lineId="orderAmount"
                :yUnit="unit.yuan"
                :data="orderFee"
              ></station-line>
            </div>
            <div class="flex">
              <div class="line-title">
                {{ lineTitle }}充电量<br /><br />{{ chargeSum }}kW
              </div>
              <!-- <div class="line-title">{{lineTitle}}充电量</div> -->
              <station-line
                v-if="flag"
                :lineId="chargingCapacity"
                :yUnit="unit.kW"
                :data="chargeNum"
              ></station-line>
            </div>
            <div class="flex">
              <div class="line-title">
                {{ lineTitle }}订单量<br /><br />{{ orderNum }}单
              </div>
              <!-- <div class="line-title">{{lineTitle}}订单量</div> -->
              <station-line
                v-if="flag"
                :lineId="orderQuantity"
                :yUnit="unit.dan"
                :data="orderSum"
              ></station-line>
            </div>
            <div class="flex">
              <div class="line-title">
                {{ lineTitle }}充电用户<br /><br />{{ custNum }}人
              </div>
              <!-- <div class="line-title">{{lineTitle}}充电用户</div> -->
              <station-line
                v-if="flag"
                :lineId="chargingUser"
                :yUnit="unit.ren"
                :data="custSum"
              ></station-line>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from './page-config'
import stationLine from './echarts-line'
export default {
  components: {
    stationLine,
  },
  data() {
    return {
      pageConfig,
      pageTitle: '电站报表',
      // 默认值设置
      detailForm: {},
      lineTitle: '近七日',
      lineChartType: 'day',
      orderAmount: 'orderAmount',
      chargingCapacity: 'chargingCapacity',
      orderQuantity: 'orderQuantity',
      chargingUser: 'chargingUser',
      unit: {
        yuan: '元',
        kW: 'kW',
        dan: '单',
        ren: '人',
      },
      pileStationRptDto: {},
      rptDetailDtoList7Days: [],
      rptDetailDtoListMonth: [],
      rptDetailDtoListYear: [],
      xAxis: [],
      orderFee: [],
      //chargeSum: [],
      //orderNum: [],
      //custNum: [],
      orderFeeAll: 0,
      chargeSumAll: 0,
      orderNumAll: 0,
      custNumAll: 0,
      flag: false,
      unit: {
        yuan: '元',
        kW: 'kW·h',
        dan: '单',
        ren: '人',
      },
      orderFee: {
        //本年度订单金额数据
        xAxis: [],
        thisData: [],
        lastData: [],
      },
      chargeNum: {
        //本年度充电量
        xAxis: [],
        thisData: [],
        lastData: [],
      },
      orderSum: {
        //本年度订单量
        xAxis: [],
        thisData: [],
        lastData: [],
      },
      custSum: {
        //充电用户
        xAxis: [],
        thisData: [],
        lastData: [],
      },
      feeSum: 0, //订单金额
      chargeNum: 0, //	充电量
      orderSum: 0, //	订单量
      custSum: 0, //充电用户数量
    }
  },
  methods: {
    //判断是否为编辑模式 如果是请求表单数据
    init() {
      if (this.$route.query.id) {
        this.$store.state.editId = this.$route.query.id
      }
      if (this.$route.query.stationNo) {
        this.$store.state.stationNo = this.$route.query.stationNo
      }
      if (this.$store.state.editId) {
        this.getFormInfo()
      }
    },
    // 获取表单信息
    getFormInfo() {
      let _ = this
      _.$S.getFormInfo(
        _,
        _.$A.pilestation.rpt + '/' + this.$store.state.editId,
        function(res) {
          //3768B16A-42AE-4944-AECC-FF4DB4849BFE
          _.detailForm = res.data.data
          _.detailForm.filePath = '/api/v1' + _.detailForm.filePath
          //  _.pileStationRptDto = res.data.data.pileStationRptDto;
          //  _.rptDetailDtoList7Days = res.data.data.pileStationRptDto.rptDetailDtoList7Days;
          //  _.rptDetailDtoListMonth = res.data.data.pileStationRptDto.rptDetailDtoListMonth;
          //  _.rptDetailDtoListYear = res.data.data.pileStationRptDto.rptDetailDtoListYear;
          //  if(_.rptDetailDtoList7Days){
          //     _.rptDetailDtoList7Days.forEach(item => {
          //         _.xAxis.push(item.chargeDay);
          //         _.orderFee.push(item.feeSum);
          //         _.chargeSum.push(item.chargeSum);
          //         _.orderNum.push(item.orderNum);
          //         _.custNum.push(item.custNum);
          //         _.orderFeeAll = _.orderFeeAll + item.feeSum;
          //         _.chargeSumAll = _.chargeSumAll + item.chargeSum;
          //         _.orderNumAll = _.orderNumAll + item.orderNum;
          //         _.custNumAll = _.custNumAll + item.custNum;
          //     })
          //     _.flag = true;
          // }
        }
      )
      _.$H
        .get(
          _,
          _.$A.pilestation.rptfrom + '/' + this.$store.state.stationNo,
          {}
        )
        .then((res) => {
          _.pileStationRptDto = res.data.data
        })
      var obj = {
        stationNo: this.$store.state.stationNo,
        chartDateType: '7',
      }
      _.flag = false
      _.orderFee.thisData = []
      _.chargeNum.thisData = []
      _.orderSum.thisData = []
      _.orderFee.xAxis = []
      _.chargeNum.xAxis = []
      _.orderSum.xAxis = []
      _.orderFee.lastData = []
      _.chargeNum.lastData = []
      _.orderSum.lastData = []
      _.custSum.thisData = []
      _.custSum.xAxis = []
      _.custSum.lastData = []
      _.feeSum = ''
      _.chargeSum = ''
      _.orderNum = ''
      _.custNum = ''
      _.$H.post(_, _.$A.pilestation.rptchart, obj).then((res) => {
        _.feeSum = res.data.data.feeSum
        _.chargeSum = res.data.data.chargeSum
        _.orderNum = res.data.data.orderNum
        _.custNum = res.data.data.custNum
        res.data.data.pileStationRptDetailDtoMap.thisData.forEach(
          (item, index) => {
            _.orderFee.thisData.push(item.feeSum)
            _.orderFee.xAxis.push(item.chargeDay)
            _.chargeNum.thisData.push(item.chargeSum)
            _.chargeNum.xAxis.push(item.chargeDay)
            _.orderSum.thisData.push(item.orderNum)
            _.orderSum.xAxis.push(item.chargeDay)
            _.custSum.thisData.push(item.custNum)
            _.custSum.xAxis.push(item.chargeDay)
          }
        )
        res.data.data.pileStationRptDetailDtoMap.lastData.forEach(
          (item, index) => {
            _.orderFee.lastData.push(item.feeSum)
            _.chargeNum.lastData.push(item.chargeSum)
            _.orderSum.lastData.push(item.orderNum)
            _.custSum.lastData.push(item.custNum)
          }
        )
        setTimeout(function() {
          _.flag = true
        }, 400)
      })
    },
    //近7日数据
    handleDayClick() {
      let _ = this
      _.lineChartType = 'day'
      _.lineTitle = '近七日'
      _.flag = false
      _.orderFee.thisData = []
      _.chargeNum.thisData = []
      _.orderSum.thisData = []
      _.orderFee.xAxis = []
      _.chargeNum.xAxis = []
      _.orderSum.xAxis = []
      _.orderFee.lastData = []
      _.chargeNum.lastData = []
      _.orderSum.lastData = []
      _.custSum.thisData = []
      _.custSum.xAxis = []
      _.custSum.lastData = []
      _.feeSum = ''
      _.chargeSum = ''
      _.orderNum = ''
      _.custNum = ''
      var obj = {
        stationNo: this.$store.state.stationNo,
        chartDateType: '7',
      }
      _.$H.post(_, _.$A.pilestation.rptchart, obj).then((res) => {
        _.feeSum = res.data.data.feeSum
        _.chargeSum = res.data.data.chargeSum
        _.orderNum = res.data.data.orderNum
        _.custNum = res.data.data.custNum
        res.data.data.pileStationRptDetailDtoMap.thisData.forEach(
          (item, index) => {
            _.orderFee.thisData.push(item.feeSum)
            _.orderFee.xAxis.push(item.chargeDay)
            _.chargeNum.thisData.push(item.chargeSum)
            _.chargeNum.xAxis.push(item.chargeDay)
            _.orderSum.thisData.push(item.orderNum)
            _.orderSum.xAxis.push(item.chargeDay)
            _.custSum.thisData.push(item.custNum)
            _.custSum.xAxis.push(item.chargeDay)
          }
        )
        res.data.data.pileStationRptDetailDtoMap.lastData.forEach(
          (item, index) => {
            _.orderFee.lastData.push(item.feeSum)
            _.chargeNum.lastData.push(item.chargeSum)
            _.orderSum.lastData.push(item.orderNum)
            _.custSum.lastData.push(item.custNum)
          }
        )
        setTimeout(function() {
          _.flag = true
        }, 400)
      })
    },
    //本月数据
    handleMonthClick() {
      let _ = this
      _.lineChartType = 'month'
      _.lineTitle = '本月'
      _.flag = false
      _.orderFee.thisData = []
      _.chargeNum.thisData = []
      _.orderSum.thisData = []
      _.orderFee.xAxis = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
      ]
      _.chargeNum.xAxis = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
      ]
      _.orderSum.xAxis = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
      ]
      _.orderFee.lastData = []
      _.chargeNum.lastData = []
      _.orderSum.lastData = []
      _.custSum.thisData = []
      _.custSum.xAxis = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
      ]
      _.custSum.lastData = []
      _.feeSum = ''
      _.chargeSum = ''
      _.orderNum = ''
      _.custNum = ''
      var obj = {
        stationNo: this.$store.state.stationNo,
        chartDateType: '30',
      }
      _.$H.post(_, _.$A.pilestation.rptchart, obj).then((res) => {
        _.feeSum = res.data.data.feeSum
        _.chargeSum = res.data.data.chargeSum
        _.orderNum = res.data.data.orderNum
        _.custNum = res.data.data.custNum
        res.data.data.pileStationRptDetailDtoMap.thisData.forEach(
          (item, index) => {
            _.orderFee.thisData.push(item.feeSum)
            _.chargeNum.thisData.push(item.chargeSum)
            _.orderSum.thisData.push(item.orderNum)
            _.custSum.thisData.push(item.custNum)
          }
        )
        res.data.data.pileStationRptDetailDtoMap.lastData.forEach(
          (item, index) => {
            _.orderFee.lastData.push(item.feeSum)
            _.chargeNum.lastData.push(item.chargeSum)
            _.orderSum.lastData.push(item.orderNum)
            _.custSum.lastData.push(item.custNum)
          }
        )
        setTimeout(function() {
          _.flag = true
        }, 400)
      })
    },
    //本年度数据
    handleYearClick() {
      let _ = this
      _.lineChartType = 'year'
      _.lineTitle = '本年度'
      _.flag = false
      _.orderFee.xAxis = [
        '1月',
        '2月',
        '3月',
        '4月',
        '5月',
        '6月',
        '7月',
        '8月',
        '9月',
        '10月',
        '11月',
        '12月',
      ]
      _.chargeNum.xAxis = [
        '1月',
        '2月',
        '3月',
        '4月',
        '5月',
        '6月',
        '7月',
        '8月',
        '9月',
        '10月',
        '11月',
        '12月',
      ]
      _.orderSum.xAxis = [
        '1月',
        '2月',
        '3月',
        '4月',
        '5月',
        '6月',
        '7月',
        '8月',
        '9月',
        '10月',
        '11月',
        '12月',
      ]
      _.orderFee.lastData = []
      _.chargeNum.lastData = []
      _.orderSum.lastData = []
      _.orderFee.thisData = []
      _.chargeNum.thisData = []
      _.orderSum.thisData = []
      _.custSum.thisData = []
      _.custSum.xAxis = [
        '1月',
        '2月',
        '3月',
        '4月',
        '5月',
        '6月',
        '7月',
        '8月',
        '9月',
        '10月',
        '11月',
        '12月',
      ]
      _.custSum.lastData = []
      _.feeSum = ''
      _.chargeSum = ''
      _.orderNum = ''
      _.custNum = ''
      var obj = {
        stationNo: this.$store.state.stationNo,
        chartDateType: '365',
      }
      _.$H.post(_, _.$A.pilestation.rptchart, obj).then((res) => {
        _.feeSum = res.data.data.feeSum
        _.chargeSum = res.data.data.chargeSum
        _.orderNum = res.data.data.orderNum
        _.custNum = res.data.data.custNum
        res.data.data.pileStationRptDetailDtoMap.thisData.forEach(
          (item, index) => {
            _.orderFee.thisData.push(item.feeSum)
            _.chargeNum.thisData.push(item.chargeSum)
            _.orderSum.thisData.push(item.orderNum)
            _.custSum.thisData.push(item.custNum)
          }
        )
        res.data.data.pileStationRptDetailDtoMap.lastData.forEach(
          (item, index) => {
            _.orderFee.lastData.push(item.feeSum)
            _.chargeNum.lastData.push(item.chargeSum)
            _.orderSum.lastData.push(item.orderNum)
            _.custSum.lastData.push(item.custNum)
          }
        )
        setTimeout(function() {
          _.flag = true
        }, 400)
      })
    },
  },
  mounted() {
    this.init()
  },
}
</script>
